// extracted by css-extract-rspack-plugin
export default {"sorter":"Sorter_sorter__wK5vN","icon":"Sorter_icon__JLSmZ","content":"Sorter_content__5HsyX"};